import { render } from "./RolesView.vue?vue&type=template&id=39ba54e5"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__